import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { WorkspaceModule } from '../../../../workspace/workspace.module';

@Component({
  selector: 'app-kanban-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    WorkspaceModule,
  ],
  templateUrl: './kanban-dashboard-page.component.html',
})
export class KanbanDashboardPageComponent { }
